import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import { HttpClient } from '@angular/common/http';
import { LineOrTrendedService } from '../Trend Chart/lineChart.service';
import { CrosstabService } from 'src/app/common/services/crosstab.service';
import { SignificanceService } from 'src/app/common/services/significance.service';
import { COMMON_CONSTANTS } from '../../constants/common-constants';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-lineChart',
  templateUrl: './lineChart.component.html',
  styleUrls: ['./lineChart.component.css'],
})
export class LineOrTrendChart1Component {
  LowBaseSample = COMMON_CONSTANTS.LowBase_Sample;
  InsufficientBaseSample = COMMON_CONSTANTS.InsufficientBase_Sample;
  @Input() insufficientBase: string = '';
  @Input() LowBase: string = '';
  DefaultConfidenceLevel: string = '95%';
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;

  LineChartData: any[] = [];
  ChartProperties: any;
  categoriesList: any;
  colorCodeList: any[] = [];
  seriesData: any[] = [];
  chart: any;
  custom: any[] = [];
  event: any;
  changeValue: any[] = [];
  significanceValue: any[] = [];
  sampleSizeValues: any[] = [];
  actualDataValue: any[] = [];
  chartCategories: any;
  samplesizeConstantValue = 1000;
  chartMinAxis: any;
  chartMaxAxis: any;
  showLowSample: any;
  //ColorCodes: string[] = ['#802AB7', '#00B6FF', '#2C70A3', '#802A71', '#EFB467', '#47B7AE', '#F9C099', '#2A80B7', '#B78000', '#2A80FF', '#00C7E8', '#1B4C96', '#571F8A', '#077A99', '#00C7E8'];
  NewColorCodes!: string[];
  DataLabelOn: boolean=true;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' | 'ascd' = 'ascd';
  colorDictionary:any=[];
  properties = [
    {
      "chartStyle": "area",
      "showLegend": true,
      "gridlines": false,
      "legendPosition": "bottom",
      "stacking": 0,
      "darkTheme": false,
      "axisLabelOrientation": "center",
      "chartTitlePosition": "center",
      "showDataLabel": true,
      "datalabelFormat": "percentage",
      "dataLabelPositionPPT": "center",
      "datalabelStyle": "sigchan",
      "datalabelOrientation": 0,
      "axisImage": false,
      "lineWidth": 2,
      "gridLineDashStyle": "Solid",
      "markerLineWidth": 1,
      "markerStyle": "circle",
      "title": "LineChart"
    }
  ];

  subscription!: Subscription; // To hold the subscription

  private splitHierarchyLevels(label: string): string[] {
    const s = String(label ?? '').trim();
    if (!s) {
      return [];
    }
    return s
      .split(/\s*:\s*/)
      .map((p) => p.trim())
      .filter((p) => p.length > 0);
  }

  private computeCommonHierarchyStripCount(labels: string[]): number {
    const normalized = labels.map((l) => String(l ?? '').trim()).filter((l) => l.length > 0);
    if (normalized.length < 2) {
      return 0;
    }
    const segmentLists = normalized.map((l) => this.splitHierarchyLevels(l));
    if (segmentLists.some((p) => p.length === 0)) {
      return 0;
    }
    const minLen = Math.min(...segmentLists.map((p) => p.length));
    let k = 0;
    while (k < minLen) {
      const seg0 = segmentLists[0][k];
      if (!segmentLists.every((parts) => parts[k] === seg0)) {
        break;
      }
      k++;
    }
    if (k === 0) {
      return 0;
    }
    const remainders = segmentLists.map((parts) => parts.slice(k));
    if (remainders.some((r) => r.length === 0)) {
      return 0;
    }
    return k;
  }

  private formatHierarchyDisplay(full: string, stripCount: number): string {
    if (stripCount <= 0) {
      return full == null ? '' : String(full);
    }
    const parts = this.splitHierarchyLevels(String(full));
    if (parts.length <= stripCount) {
      return String(full);
    }
    return parts.slice(stripCount).join(' : ');
  }

  constructor(
    public http: HttpClient,
    public LineTrendService: LineOrTrendedService,
    private dataSharingService: CrosstabService,
    private significanceService: SignificanceService
  ) { }

  ngOnInit(): void {
    this.LowBaseSample = this.LowBase == "" ? 0 : Number(this.LowBase);
    this.InsufficientBaseSample = this.insufficientBase == "" ? 0 : Number(this.insufficientBase);

    this.dataSharingService.LineChartDataSubject$.subscribe(({ data, listOfCategory, Significance, ConfidenceLevel, numberType, chartType }) => {
      this.LineChartData = data.Data;
      if (Significance == "None") {
        this.properties[0].datalabelStyle = '';
      }
      else {
        this.properties[0].datalabelStyle = 'sigchan';
        this.DefaultConfidenceLevel = ConfidenceLevel;
      }
      this.ChartProperties = this.properties[0];

      // Call the service to get the color palette
      this.subscription = this.dataSharingService.colorPalette$.subscribe((result: any) => {
        this.NewColorCodes = result; // Assign the color palette from the service
      });


      // this.colorCodeList = this.ColorCodes;
      this.colorCodeList = this.NewColorCodes;
      this.categoriesList = listOfCategory;
       this.dataSharingService.ColorDictionarySubject$.subscribe((colors:any)=>{
      if(colors)
      {
          this.colorDictionary=colors;
      }
    });
      this.plotLineChart('line-chartContainer', listOfCategory);
    });

    // Listen to table sorting changes
    this.dataSharingService.tableSorting$.subscribe(({sortColumn, sortDirection}) => {     
      if (sortColumn && this.LineChartData && this.LineChartData.length > 0) {       
        this.sortColumn = sortColumn;
        this.sortDirection = sortDirection;
      }
    });

    //this.categoriesList = ["Oct'2023", "Nov'2023", "Dec'2023", "Jan'2024", "Feb'2024"]
    //this.http.get<any>('assets/Data/areaChartData.json').subscribe( jsonData  => {
    //  this.LineChartData = jsonData[0].data;
    //  this.ChartProperties = this.properties[0];
    //  this.colorCodeList = this.ColorCodes;
    //  this.plotLineChart('chartContainer');
    //}, error => {
    //  console.error('Error fetching data:', error);
    //});   
  }
  DataLabelOnClick() {
    this.DataLabelOn = true;
    this.plotLineChart('line-chartContainer', this.categoriesList);
  }

  DataLabelOffClick() {
    this.DataLabelOn = false;
    this.plotLineChart('line-chartContainer', this.categoriesList);
  }
  //   data = [{
  //   CategoryId: 1,
  //   RowOption: "Asia",
  //   RowId: 35,
  //   color: "#98fb98",
  //   share: 0,
  //   xaxisshare: 0
  // },
  // {
  //   CategoryId: 2,
  //   RowOption: "Asia",
  //   RowId: 35,
  //   color: "#98fb98",
  //   share: 290,
  //   xaxisshare: 15
  // },
  // {
  //   CategoryId: 3,
  //   RowOption: "Asia",
  //   RowId: 35,
  //   color: "#98fb98",
  //   share: 480,
  //   xaxisshare: 30
  // },
  // {
  //   CategoryId: 4,
  //   RowOption: "Asia",
  //   RowId: 35,
  //   color: "#98fb98",
  //   share: 620,
  //   xaxisshare: 45
  // },
  // {
  //   CategoryId: 5,
  //   RowOption: "Asia",
  //   RowId: 35,
  //   color: "#98fb98",
  //   share: 620,
  //   xaxisshare: 60
  // }, {
  //   CategoryId: 1,
  //   RowOption: "Africa",
  //   RowId: 36,
  //   color: "#f8e473",
  //   share: 0,
  //   xaxisshare: 0
  // },
  // {
  //   CategoryId: 2,
  //   RowOption: "Africa",
  //   RowId: 36,
  //   color: "#f8e473",
  //   share: 250,
  //   xaxisshare: 15
  // },
  // {
  //   CategoryId: 5,
  //   RowOption: "Africa",
  //   RowId: 36,
  //   color: "#f8e473",
  //   share: 570,
  //   xaxisshare: 60
  // },
  // {
  //   CategoryId: 1,
  //   RowOption: "Europe",
  //   RowId: 37,
  //   color: "#fe7f9c",
  //   share: 0,
  //   xaxisshare: 0

  // }, {
  //   CategoryId: 2,
  //   RowOption: "Europe",
  //   RowId: 37,
  //   color: "#fe7f9c",
  //   share: 220,
  //   xaxisshare: 15

  // }, {
  //   CategoryId: 4,
  //   RowOption: "Europe",
  //   RowId: 37,
  //   color: "#fe7f9c",
  //   share: 430,
  //   xaxisshare: 45

  // }, {
  //   CategoryId: 5,
  //   RowOption: "Europe",
  //   RowId: 37,
  //   color: "#fe7f9c",
  //   share: 505,
  //   xaxisshare: 60

  //     };

  customization() {
    return this.LineTrendService.customizationService()
  }

  commonfunc(event: any, customization: string, options: any) {

    this.event = event;
    this.ChartProperties = this.LineTrendService.commonFunc(customization, event, this.ChartProperties)
    this.plotLineChart('line-chartContainer', null);
  }

  plotyaxis() {

    if (this.ChartProperties.stacking == 1) {
      return {
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? "white" : "Black"
          }
        },
        visible: true,
        gridLineWidth: 1,
        labels: {
          style: {
            color: this.ChartProperties.darkTheme ? "white" : "Black"
          }
        }
      }
    } else {
      return {
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? "white" : "Black"
          }
        },
        min: 0,
        max: this.chartMaxAxis > 100 ? this.chartMaxAxis : 100,
        gridLineWidth: 1,
        visible: true,
        labels: {
          style: {
            color: this.ChartProperties.darkTheme ? "white" : "Black"
          }
        }
      }
    }
  }
  
  getSigLowerLimit() {
    return this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel);
  }
  
  getSigUpperLimit() {
    return this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel);
  }
  plotLineChart(containerId: any, listOfCategory: any) {
    localStorage.setItem("properties", JSON.stringify(this.ChartProperties));
    this.prepareSeriesDataForChart(listOfCategory);
    let properties = this.ChartProperties;
    let samplesizeConstantValue = this.samplesizeConstantValue;
    let lowSampleValue = this.showLowSample;
    let getTooltipValue = this.getTooltipValue;
    const updatedCategoryNames = this.LineTrendService.updatedCategories.map(category => category.image);
    let updatedCategories = this.LineTrendService.updatedCategories;
    let ispercentage = false;
    let InsufficientBase = this.InsufficientBaseSample;
    let lowSample = this.LowBaseSample;
      let sigLowerValue = this.getSigLowerLimit();
    let sigUpperValue = this.getSigUpperLimit();
    if (this.ChartProperties.datalabelFormat === "percentage") {
      ispercentage = true;
    }
    // Prefer explicit metric metadata; retain name-based mean detection for legacy callers.
    const getPointIsPercentage = (pointData: any): boolean =>
      pointData?.isPercentage ??
      (ispercentage && !pointData?.['Series Name']?.toString().toLowerCase().includes('mean'));
    let datalabelon=this.DataLabelOn;
    if (this.ChartProperties.stacking == 1 || this.ChartProperties.stacking == 2) {
      this.seriesData.reverse();
    }
    const containerEl = document.getElementById(containerId);
    if (!containerEl) { return; }
    this.chart = new Highcharts.Chart(containerEl, {
      chart: {
        type: 'line',
        zooming: {
          type: 'xy'
        },
        marginLeft: 50,   // Increase left margin
        marginRight: 30,
        backgroundColor: this.ChartProperties.darkTheme ? "Black" : "white",
        style: {
          color: this.ChartProperties.darkTheme ? "white" : "Black",
          fontFamily:"KantarBrown-Regular"
        },
        resetZoomButton: {
          position: {
              align: 'right', // Align to the right
              verticalAlign: 'top', // Align to the top
              x: 0,
              y: 0
          },
          theme: {
              width: 55,       // Custom width
              height: 8,  
              style: {
                  fontSize: '10px',
                  fontFamily: "KantarBrown-Regular"
              }
          }
        }
      },
      title: {
        text: this.ChartProperties.chartTitle,
        style: {
          color: this.ChartProperties.darkTheme ? "white" : "Black",
        },
      },
      credits: {
        enabled: false
      },
      //yAxis: {
      //  visible: false // Correct syntax to hide the y-axis
      //},
      yAxis: this.plotyaxis(),
      xAxis: {
        title: {
          text: '',
          style: {
            fontSize: '12px',
            color: '#E8E8E8'
          }
        },
      
        crop: false, // Change from true to false to prevent cropping/truncation
  overflow: 'hidden', // Allow labels to overflow instead of being cropped
  gridLineWidth: this.ChartProperties.gridlines,
  categories: properties.axisImage ? updatedCategoryNames.map(label => label.replace(/^(Month|Year|Quarter)\s*:\s*/, '')) : this.categoriesList.map((label: string) => label.replace(/^(Month|Year|Quarter)\s*:\s*/, '')),
  min: 0,
  max: this.categoriesList.length > 15? 15 : this.categoriesList.length - 1,
  scrollbar: {
    enabled: this.categoriesList.length > 15 ? true : false,
    height: 6, // Adjust the height of the scrollbar as needed
    margin: 25, // Add margin to push scrollbar down
    barBackgroundColor: '#999',
    barBorderRadius: 3,
    barBorderWidth: 0,
    buttonBackgroundColor: 'transparent',
    buttonBorderWidth: 0,
    buttonArrowColor: '#aaa',
    rifleColor: 'transparent',
    trackBackgroundColor: '#f5f5f5',
    trackBorderWidth: 0,
    trackBorderRadius: 3,
    barHoverStyle: {
      backgroundColor: '#444444'
    }
  },
  labels: {
    rotation: this.LineTrendService.axisLabelOrientation(this.ChartProperties.axisLabelOrientation),
    style: {
      
      color: '#000000',
      fontSize: '0.7rem',
      fontWeight: 400,
      align:'right',
      textOverflow: 'none' // Prevent text overflow truncation
    },
    x:0,
    //  useHTML: true,
  // formatter: function(this: any) {
  //  const totalCategories = this.axis.categories ? this.axis.categories.length : 0;
  //     const currentIndex = this.pos;
      
  //     // Always show first label
  //     if (currentIndex === 0) {
  //       return this.value;
  //     }
      
  //          if (currentIndex === totalCategories - 1) {
  //     return '<span style="    margin-left: -5rem;    display: inline-block;">' + this.value + '</span>';
  //   }
      
  //     // For middle labels, show every 3rd position (step = 3)
  //     // But skip positions that are too close to first or last
  //     // if (currentIndex % 3 === 0 && 
  //     //     currentIndex > 2 && 
  //     //     currentIndex < totalCategories - 3) {
  //     //   return this.value;
  //     // }
    
  //   return this.value;; // Hide other labels
  // }
        }
      },

      tooltip: {
        enabled: true,
        borderWidth: 0,
        useHTML: true,
        shape: 'callout',
        shadow: false,
        backgroundColor: 'rgba(0,0,0,0)',
        formatter: function (this: any) { //for formatting tooltip
          const dotColor = this.series.color;
          const ispercentage = getPointIsPercentage(this.series.userOptions.data1[this.point.x]);

          return '<div style="background-color: #f5f5f5; padding: 5px; align-items: center; border: 1px solid ' + dotColor + ';">' +
            (this.series.userOptions.displayName || this.series.userOptions.name) + "</br>" +
            this.series.userOptions.data1[this.point.x]["Category Name"] + ' : ' +
            getTooltipValue(this.y, this.series.userOptions.data1[this.point.x]["Rounded Value"], this.series.userOptions.data1[this.point.x]["Sample Size"], ispercentage, InsufficientBase, lowSample) +
            '</div>';

        }
      },
      //legend: this.LineTrendService.customizeLegend(properties.showLegend, properties.legendPosition, this.ChartProperties.darkTheme, this.ChartProperties.stacking),
      legend: {
        ...this.LineTrendService.customizeLegend(
          properties.showLegend,
          properties.legendPosition,
          this.ChartProperties.darkTheme,
          this.ChartProperties.stacking
        ),
       style:{
        fontSize: '0.5rem',
       },
        labelFormatter: function (this: any) {
          const uo = this.userOptions || {};
          return uo.displayName != null && uo.displayName !== ''
            ? uo.displayName
            : this.name;
        },
      },
      plotOptions: {
        line: {
          stacking: this.ChartProperties.stacking == 0 ? "" : (this.ChartProperties.stacking == 1 ? "normal" : "percent"),
          lineWidth: properties.lineWidth,
          dashStyle: properties.gridLineDashStyle,
          fillOpacity: 0.4,
          marker: {
            enabled: true,
            symbol: properties.markerStyle,
            radius: 4,
            lineWidth: properties.markerLineWidth,
          },
          dataLabels: {
            enabled: datalabelon,
            align: properties.dataLabelPositionPPT,
            rotation: properties.datalabelOrientation,
            backgroundColor: 'transparent',
            formatter: function (this: any) {
              let idx = 0;
              const ispercentage = getPointIsPercentage(this.series.userOptions.data1[this.point.x]);

              if (properties.datalabelStyle == "sigchan") {
                this.Sig_LowerLimt = sigLowerValue;
                this.Sig_UpperLimt = sigUpperValue;
     

                let text = this.y == 0.000001 ? 'NA' : this.y + (ispercentage ? '%' : '');
                let changevspy = (isNaN(this.series.userOptions.data1[this.point.x]["Change value vs PY"]) ? "(NA)" : ('(' + this.series.userOptions.data1[this.point.x]["Change value vs PY"] + (ispercentage ? '%' : '') + ')'));
                let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                const sampleSize = this.series.userOptions.data1[this.point.x]['Sample Size'];

                // If insufficient base: show I/S plus change string e.g. I/S(NA) or I/S(-3%)
                if (sampleSize != 0 && sampleSize < InsufficientBase) {
                  // Determine significance color for change part (if numeric)
                  let changeVal = this.series.userOptions.data1[this.point.x]["Change value vs PY"]; 
                  let changeColored = changevspy;
                  // if (!isNaN(changeVal)) {
                  //   if (sig < this.Sig_LowerLimt) {
                  //     changeColored = '<span style="color:red;">(' + changeVal + (ispercentage ? '%' : '') + ')</span>';
                  //   } else if (sig > this.Sig_UpperLimt) {
                  //     changeColored = '<span style="color:green;">(' + changeVal + (ispercentage ? '%' : '') + ')</span>';
                  //   }
                  // }
                  return '<span>I/S' + '</span>';
                }

                if (text == 'NA') {
                  return (
                    '<span >' + text + '</span>'
                  );
                }
                else if (changevspy == '(NA)') {
                  return (
                    '<span>' + text + '<span>' + changevspy + '</span></span>'
                  );
                }
                if (sig < this.Sig_LowerLimt) {
                  return (
                    '<span>' + text + '<span  style="color: red;">' + changevspy + '</span></span>'
                  )
                } else if (sig > this.Sig_UpperLimt) {
                  return (
                    '<span>' + text + '<span  style="color: green;">' + changevspy + '</span></span>'
                  )
                }
                else {
                  return (
                    '<span>' + text + '<span>' + changevspy + '</span></span>'
                  );
                }
              }

              return (this.series.userOptions.data1[this.point.x]['Sample Size'] != 0 && this.series.userOptions.data1[this.point.x]['Sample Size'] < InsufficientBase)
                ? 'I/S'
                : this.y == 0.000001
                  ? 'NA'
                  : (this.series.userOptions.data1[this.point.x]['Sample Size'] != 0 && (this.series.userOptions.data1[this.point.x]['Sample Size'] < lowSample && this.series.userOptions.data1[this.point.x]['Sample Size'] > InsufficientBase))
                    ? (this.y + (ispercentage ? '%' : '') + ('*'))
                    : (this.y + (ispercentage ? '%' : ''));
              //return this.y != 0 ? this.y + (ispercentage && '%') : 'NA';
            }
          }
        }

      },
      series: this.seriesData,
    } as any);

    var chart = this.chart;
    var legendWidth = chart.legend.legendWidth;
    // Adjust margins based on the legend width

    if (this.ChartProperties.legendPosition == "left" && this.ChartProperties.showLegend) {
      this.chart.update({
        chart: {
          marginLeft: legendWidth + 40, // Add some extra space
          marginRight: 30
        }
      }, false);
    }

    if (this.ChartProperties.legendPosition == "right" && this.ChartProperties.showLegend) {
      this.chart.update({
        chart: {
          marginLeft: legendWidth + 5, // Add some extra space
          marginRight: legendWidth + 25
        }
      }, false);
    }

  }

  getTooltipValue(value: any, actualValue: any, sampleSize: any, ispercentage: boolean, InsufficientBaseSample: any, LowBaseSample: any) {
    if (sampleSize != 0 && (sampleSize < InsufficientBaseSample)) {
      return actualValue = 'I/S';
    }
    else if (sampleSize != 0 && (sampleSize < LowBaseSample && sampleSize > InsufficientBaseSample)) {
      return actualValue = ispercentage ? (actualValue + '% *') : (actualValue + ' *');
    }
    else if (actualValue == null || actualValue == "NA") {
      return 'NA';
    }
    else {
      return actualValue = ispercentage ? (actualValue + '%') : (actualValue);
    }
  }
  prepareSeriesDataForChart(listOfCategory: any) {
    this.seriesData = [];
    let metrics = _.uniqBy(this.LineChartData, "Series Name").map(item => {
      return item["Series Name"];
    });

    let uniqueDataValue = _.uniqBy(this.LineChartData, "Rounded Value").map(item => {
      return item["Rounded Value"] == "NA" ? 0 : item["Rounded Value"];
    });

    if (this.ChartProperties.datalabelStyle === "lowSample") {
      this.showLowSample = true;
    } else {
      this.showLowSample = false;
    }

    let minValue = Math.min(...uniqueDataValue);
    let maxValue = Math.max(...uniqueDataValue);
    this.chartMinAxis = 0;
    this.chartMaxAxis = maxValue + maxValue * 0.05

    let idx = 0;
    let dataObject: any = {};
    let consumableData: any = [];
    let consumableData1: any = [];

    const lineSeriesStripK = this.computeCommonHierarchyStripCount(metrics.map((m) => String(m)));

    metrics.forEach((metric) => {
      //listOfCategory.forEach((catName: any) => {
      dataObject = {};
      consumableData = [];
      consumableData1 = [];
      let metricData = this.LineChartData.filter(res => res["Series Name"] == metric);

      let sortedMetricData = metricData.sort((a, b) => {
        // Get the index of category name in the list of categories
        let indexA = listOfCategory.indexOf(a["Category Name"]);
        let indexB = listOfCategory.indexOf(b["Category Name"]);

        // Compare the indices
        return indexA - indexB;
      });
      for (var i = 0; i < listOfCategory.length; i++) {
        let FilteredData = sortedMetricData.filter(x => x['Category Name'] == listOfCategory[i])[0];

        // FilteredData.forEach(item => {
  dataObject.name = metric;
   dataObject.displayName = this.formatHierarchyDisplay(String(metric), lineSeriesStripK);

        consumableData.push({
          y: FilteredData["Rounded Value"] == "NA" ? 0.000001 : (FilteredData["Sample Size"] != 0 && FilteredData["Sample Size"] < this.InsufficientBaseSample) ? 0.000001 : FilteredData["Rounded Value"]
        })
        consumableData1.push(FilteredData);
        // })
      }
      const existingSeriesColor = sortedMetricData.find((item: any) => item?.color)?.color;
      dataObject.color = existingSeriesColor || this.colorCodeList[idx];
      idx++;
      dataObject.data = consumableData;
      dataObject.data1 = consumableData1;
      dataObject.pointPlacement = "on";
      this.seriesData.push(dataObject);
      //})
    })
    if(this.colorDictionary.length==0)
    {
      let ColorDictionary:any=[];
       this.seriesData.forEach((series, index) => {
        ColorDictionary.push({name:series.name.replace(/\s+/g, ""),color:series.color})
      });
      this.dataSharingService.setColorDictionary(ColorDictionary);
    }
    else{
      this.seriesData.forEach((series, index) => {
             let customcolor =  this.colorDictionary.find((x: any)=>x.name==series.name.replace(/\s+/g, ""));
        series.color = customcolor.color;
      
      });
    }
  }

  getDataValue(sampleSize: any, value: any) {

    if (sampleSize >= this.samplesizeConstantValue)
      return value;
    return 0;
  }

  userselectedproperties() {

    let linechartData = {
      data: this.LineChartData,
      Properties: [this.ChartProperties]
    }
    return JSON.stringify(linechartData).toString();
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.chart) {
      this.chart.destroy();
      this.chart = null as any;
    }
  }
}
